import React, { useEffect, useState } from "react";
import CompanyAPIs from "../../../../../MasonyFixingsAPIs/CompanyAPIs/CompanyAPIs";
import AddressAPIs from "../../../../../MasonyFixingsAPIs/AddressAPIs/AddressAPIs";
import DropDown from "../../../../DropDown/DropDown";
import { Form, Row, Col, Card } from "react-bootstrap";
import { FaChevronUp, FaChevronDown, FaSave } from "react-icons/fa";
import { AiFillEdit } from "react-icons/ai";
import { MdCancel, MdEdit } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import LookupAPIs from "../../../../../MasonyFixingsAPIs/LookupAPIs/LookupAPIs";
import ApiResponseHandler from "../../../../../MasonyFixingsAPIs/ApiResponseHandler";
import { useToast } from "../../../../../Contexts/ToastContext";

export default function ViewCompanyHeadOffice({companyID}){

    const {addToast} = useToast();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [editing, setEditing] = useState(false);
    const [sending, setSending] = useState(false);
    const [showHeadOffice, setShowHeadOffice] = useState(false);

    const [headOfficeData, setHeadOfficeData] = useState();
    const [addressData, setAddressData] = useState();
    const [phone, setPhone] = useState();
    const [line1, setLine1] = useState();
    const [line2, setLine2] = useState('');
    const [city, setCity] = useState();
    const [countyID, setCountyID] = useState();
    const [countryID, setCountryID] = useState();
    const [counties, setCounties] = useState([]);
    const [countries, setCountries] = useState([]);

    const getHeadOffice = (compID) => {

        CompanyAPIs.GetCompanyHeadOffice(compID)
        .then((response) => {
            if(response.status === 200){
                setHeadOfficeData(response.data);
                setPhone(response.data.phone);
                AddressAPIs.GetAddress(response.data.address_id)
                .then((response) => {
                    if(response.status === 200){
                        setAddressData(response.data);
                        setLine1(response.data.line1 === null ? '' : response.data.line1);
                        setLine2(response.data.line2 === null ? '' : response.data.line2);
                        setCity(response.data.city === null ? '' : response.data.city);
                        setCountyID(response.data.county_id === null ? '' : response.data.county_id);
                        setCountryID(response.data.country_id === null ? '' : response.data.country_id);
                        setLoading(false);
                    }
                })
                .catch((err) => {
                    console.log(err)
                    if(err.response.status === 401){
                        if(err.response.data.logout){
                            navigate('/login');
                        }
                        else{
                            window.alert(err.response.data.message)
                        }
                    }
                })
            }
        })
        .catch((err) => {
            console.log(err)
            if(err.response.status === 401){
                if(err.response.data.logout){
                    navigate('/login');
                }
                else{
                    window.alert(err.response.data.message)
                }
            }
        })
    }

    const editHeadOffice = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setSending(true);
        const putJSON = {
            phone: phone,
            address_id: headOfficeData.address_id  === '' ? null : headOfficeData.address_id,
            line1: line1  === '' ? null : line1,
            line2: line2  === '' ? null : line2,
            city: city  === '' ? null : city,
            county_id: countyID  === '' ? null : countyID,
            country_id: countryID  === '' ? null : countryID 
        }

        CompanyAPIs.PutCompanyHeadOffice(companyID, putJSON)
        .then((response) => {
            if(response.status === 200){
                getHeadOffice(companyID);
                setEditing(false);
                setSending(false);
                addToast({ message: "Head Office updated successfully!", variant: "success", autoHide: true });
            }
        })
        .catch((err) => {
            console.log(err)
            setSending(false);
            if(err.response.status === 401){
                if(err.response.data.logout){
                    navigate('/login');
                }
                else{
                    window.alert(err.response.data.message)
                }
            }
        })
    }

    const handleCancel = () => {
        setPhone(headOfficeData.phone === null ? '' : headOfficeData.phone);
        setLine1(addressData.line1 === null ? '' : headOfficeData.line1);
        setLine2(addressData.line2 === null ? '' : headOfficeData.line2);
        setCity(addressData.city === null ? '' : headOfficeData.city);
        setCountyID(addressData.county_id === null ? '' : headOfficeData.county_id);
        setCountryID(addressData.country_id === null ? '' : headOfficeData.country_id);
        setEditing(false);
    }
    const getCounties = () => {
        LookupAPIs.GetCounties()
        .then((response) => {
            setCounties(response.data);
        })
        .catch((err) => {
            ApiResponseHandler(err.response, navigate);
        })
    }

    const getCountries = () => {
        LookupAPIs.GetCountries()
        .then((response) => {
            setCountries(response.data);
        })
        .catch((err) => {
            ApiResponseHandler(err.response, navigate);
        })
    }

    useEffect(() => {
        getCounties();
        getCountries();
    }, [])

    useEffect(() => {
        getHeadOffice(companyID);
    }, [companyID])

    if(loading){
        return(
            <div>Loading Head Office...</div>
        )
    }
    else{
        return(
            
            <div className="project-section"> 
                <Form onSubmit={editHeadOffice}>
                <div className="project-seciton-header">
                    <h4 className="section-title">Head Office</h4>
                    <div className="project-header-actions">
                        <button
                            disabled={sending || !editing}
                            type="submit"
                            className="save-btn"
                            style={editing ? {display: 'block'} : {display: 'none'}}
                        >
                            {sending ? 'Saving...' : 'Save'}
                        </button>

                        {editing ? (
                            <button
                                disabled={sending}
                                type="button"
                                className="cancel-btn"
                                onClick={handleCancel}
                            >
                                Cancel
                            </button>
                        ) : (
                            <button
                                disabled={sending}
                                type="button"
                                className="edit-btn"
                                onClick={() => setEditing(true)}
                            >
                                <MdEdit /> Edit
                            </button>
                        )}
                    </div>
                </div>


                <div className="project-section-body">

                    {editing ? 
                            <div className="project-section-body-item">
                                <span className="label">Phone:</span>
                                <Form.Control
                                    disabled={!editing}
                                    value={phone}
                                    onChange={(e) => setPhone(e.target.value)}
                                    className="editable-field"
                                />
                            </div>
                        :
                        <div className="project-section-body-item">
                                <span className="label">Phone:</span>
                                <span>{addressData.phone}</span>
                        </div>
                
                    }
                
                
                    {editing ? 
                            <div className="project-section-body-item">
                                <span className="label">Line 1:</span>
                                <Form.Control
                                    required
                                    disabled={!editing}
                                    value={line1}
                                    onChange={(e) => setLine1(e.target.value)}
                                    className="editable-field"
                                />
                            </div>
                        :
                        <div className="project-section-body-item">
                                <span className="label">Line 1:</span>
                                <span>{addressData.line1}</span>
                        </div>
                
                    }

                    {editing ? 
                            <div className="project-section-body-item">
                                <span className="label">Line 2:</span>
                                <Form.Control
                                    disabled={!editing}
                                    value={line2}
                                    onChange={(e) => setLine2(e.target.value)}
                                    className="editable-field"
                                />
                            </div>
                        :
                        <div className="project-section-body-item">
                                <span className="label">Line 2:</span>
                                <span>{addressData.line2}</span>
                        </div>
                
                    }

                    {editing ? 
                            <div className="project-section-body-item">
                                <span className="label">City:</span>
                                <Form.Control
                                    disabled={!editing}
                                    value={city}
                                    onChange={(e) => setCity(e.target.value)}
                                    className="editable-field"
                                />
                            </div>
                        :
                        <div className="project-section-body-item">
                                <span className="label">City:</span>
                                <span>{addressData.city}</span>
                        </div>
                
                    }
                    



                    {editing ? 
                                <div className="project-section-body-item">
                                <span className="label">County:</span>
                                <DropDown.County
                                    required
                                    disabled={!editing}
                                    value={countyID}
                                    className="editable-field"
                                    onChange={(e) => setCountyID(e.target.value)}
                                />
                            </div>
                        :
                        <div className="project-section-body-item">
                                <span className="label">County:</span>
                                <span>{counties.find((c) => c.id == addressData.county_id)?.county ?? ''}</span>
                        </div>
                
                    }


                    {editing ? 
                            <div className="project-section-body-item">
                                <span className="label">Country:</span>
                                <DropDown.Country
                                    required
                                    disabled={!editing}
                                    value={countryID}
                                    className="editable-field"
                                    onChange={(e) => setCountryID(e.target.value)}
                                />
                            </div>
                        :
                        <div className="project-section-body-item">
                                <span className="label">Country:</span>
                                <span>{countries.find((c) => c.id == addressData.country_id)?.country ?? ''}</span>
                        </div>
                
                    }
                </div>


                </Form>

                {/* <div className={showHeadOffice ? 'employee-details active' : 'employee-details'}>
                        
                <Card>
                    <Card.Body>
                        <div align='end'>
                        {editing ? 
                            <>
                                <button disabled={sending} onClick={() => editHeadOffice()}><FaSave/></button>
                                <button disabled={sending} onClick={() => handleCancel()}><MdCancel/></button>
                            </>
                            :
                            <button onClick={() => setEditing(true)}><AiFillEdit/></button>
                        }
                        </div>
                
                    
                        <Form.Group as={Row} className="mb-1">
                            <Form.Label column sm={3}>Phone</Form.Label>
                            <Col sm={8}>
                            <Form.Control disabled={sending || !editing} value={phone} onChange={(e) => setPhone(e.target.value)} />
                            </Col>
                        </Form.Group>
                        
                        <Form.Group as={Row} className="mb-1">
                            <Form.Label column sm={3}>Line 1:</Form.Label>
                            <Col sm={8}>
                                <Form.Control disabled={sending || !editing} required value={line1} onChange={(e) => setLine1(e.target.value)} />
                            </Col>
                        </Form.Group>

                        <Form.Group as={Row} className="mb-1">
                            <Form.Label column sm={3}>Line 2:</Form.Label>
                            <Col sm={8}>
                                <Form.Control disabled={sending || !editing} value={line2} onChange={(e) => setLine2(e.target.value)} />
                            </Col>
                        </Form.Group>
                        
                        <Form.Group as={Row} className="mb-1">
                            <Form.Label column sm={3}>City:</Form.Label>
                            <Col sm={8}>
                                <Form.Control disabled={sending || !editing} value={city} onChange={(e) => setCity(e.target.value)} />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-1">
                            <Form.Label column sm={3}>County:</Form.Label>
                            <Col sm={8}>
                                <DropDown.County disabled={sending || !editing} required value={countyID} onChange={(e) => setCountyID(e.target.value)} />
                            </Col>
                        </Form.Group>

                        <Form.Group as={Row} className="mb-1">
                            <Form.Label column sm={3}>Country:</Form.Label>
                            <Col sm={8}>
                                <DropDown.Country disabled={sending || !editing} required value={countryID} onChange={(e) => setCountryID(e.target.value)} />
                            </Col>
                        </Form.Group>
                    
                    
                    </Card.Body>
                </Card>
                </div> */}
                
            </div>
        )
    }
}